import { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface AddChildFormProps {
  onSubmit: (names: string[]) => void;
  onCancel: () => void;
}

export function AddChildForm({ onSubmit, onCancel }: AddChildFormProps) {
  const [names, setNames] = useState<string[]>(['']);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validNames = names.filter(name => name.trim());
    if (validNames.length > 0) {
      onSubmit(validNames);
    }
  };

  const addNameField = () => {
    setNames([...names, '']);
  };

  const removeName = (index: number) => {
    setNames(names.filter((_, i) => i !== index));
  };

  const updateName = (index: number, value: string) => {
    const newNames = [...names];
    newNames[index] = value;
    setNames(newNames);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-4">
        {names.map((name, index) => (
          <div key={index} className="flex gap-2">
            <Input
              value={name}
              onChange={(e) => updateName(index, e.target.value)}
              placeholder={`اسم المولود ${index + 1}`}
              autoFocus={index === 0}
            />
            {names.length > 1 && (
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => removeName(index)}
                className="flex-shrink-0"
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
        ))}
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={addNameField}
        className="w-full"
      >
        <Plus className="h-4 w-4 ml-2" />
        إضافة مولود آخر
      </Button>

      <div className="flex gap-2 pt-4 border-t">
        <Button 
          type="submit" 
          disabled={!names.some(name => name.trim())}
          className="flex-1"
        >
          إضافة
        </Button>
        <Button 
          type="button" 
          variant="outline" 
          onClick={onCancel}
          className="flex-1"
        >
          إلغاء
        </Button>
      </div>
    </form>
  );
}